import React, { useEffect, useState } from "react";
import { Image, Upload, message, Row, Col, Popconfirm, Card, Empty } from "antd";

import { DeleteOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { RoomServices } from "../../Services/RoomServices";
import { GeneralService } from "../../Services/GeneralService";
import { ENDPOINTS } from "../../Services/ENDPOINT";
import { notify } from "../../components/Customs/NotifyProvider";
import TitleHead from "../../components/Customs/TitleHead";


import { canViewModule, canCreateModule, canDeleteModule } from "../../../utils/permissionUtils";

const MODULE_KEY = "media_library";

const MediaLibrary = () => {
    const [mediaLibrary, setMediaLibrary] = useState([]);

    const getAllUploadedImages = async () => {
        try {
            const res = await RoomServices.getAllUploadedImages();
            setMediaLibrary(res.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    const mediaUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append("image", file);

            await GeneralService.mediaUpload(formData);

            notify.success("Image uploaded");
            getAllUploadedImages();
        } catch (error) {
            console.error(error);
            message.error("Upload failed");
        }
    };

    const deleteImage = async (img) => {
        try {
            const fileName = img.url.split("/").pop();
            console.log("Deleting file:", fileName);

            await GeneralService.mediaDelete(fileName);

            notify.success("Image Deleted !");
            getAllUploadedImages();
        } catch (error) {
            console.error(error);
            message.error("Delete failed");
        }
    };

    useEffect(() => {
        getAllUploadedImages();
    }, []);

      if (!canViewModule(MODULE_KEY)) {
        return <Empty description="No permission to view this page" />;
    }

    return (
        <Card title={
            <TitleHead h1='Media Library' h2='Store, organize & manage images and files in one centralized library' />
        }
        
        >
       <Upload
    beforeUpload={(file) => {
        mediaUpload(file);
        return false;
    }}
    accept="image/png, image/jpeg, image/jpg"
    maxCount={1}
    showUploadList={false}
    disabled={!canCreateModule(MODULE_KEY)}
>
                <div
                    style={{
                        width: 110,
                        height: 110,
                        border: "1px dashed #000000ff",
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        marginBottom: 16,
                    }}
                >
                    <CloudUploadOutlined style={{fontSize:30}} /> 
                </div>
            </Upload>

            <Image.PreviewGroup>
                <Row gutter={[12, 12]}>
                    {mediaLibrary.map((img) => {
                        const fullUrl = `${ENDPOINTS.cleanBase}${img.url}`;

                        return (
                            <Col key={img.url}>
                                <div
                                    style={{
                                        position: "relative",
                                        borderRadius: 8,
                                        overflow: "hidden",
                                    }}
                                >
                                    <Image
                                        src={fullUrl}
                                        width={110}
                                        height={110}
                                        style={{ objectFit: "cover" }}
                                    />

                                    {/* ✅ Delete Overlay */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 5,
                                            right: 5,
                                            background: "rgba(0,0,0,0.5)",
                                            borderRadius: "50%",
                                            padding: 5,
                                            cursor: "pointer",
                                        }}
                                    >
                                      {canDeleteModule(MODULE_KEY) && (
    <Popconfirm
        title="Delete image?"
        onConfirm={() => deleteImage(img)}
    >
        <DeleteOutlined style={{ color: "#fff" }} />
    </Popconfirm>
)}
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </Image.PreviewGroup>
        </Card>
    );
};

export default MediaLibrary;